module.exports = __webpack_public_path__ + "img/user106.8e314239.jpg";